import { Stack, Text } from '@mantine/core'
import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportScore from './ReportScore'
import FocusModules from './FocusModules'
import { useTheme } from '../../../components/ThemeProvider'

interface ReportOverviewProps {
  data: any
}

export default function ReportOverview({ data }: ReportOverviewProps) {
  const theme = useTheme()

  return (
    <ReportWrapper>
      <Stack gap="lg">
        <Stack gap="md">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            评分结果概览
          </Text>
          <ReportScore data={data} />
        </Stack>
        <FocusModules data={data} />
      </Stack>
    </ReportWrapper>
  )
}
